const id_trans_itemoutlist = {
    "": "supervisi barang keluar",
    detail: "detail barang keluar",

    label: {
        detail_show: "Tampilkan rincian ...",
        detail_basic: "Rincian Dasar",
        detail_full: "Rincian Lengkap",
    },

    message: {
        delete_title: "Apakah Anda yakin untuk menghapus data barang keluar?",
        delete_text: "Masukkan alasan penghapusan data barang keluar",
    },

    error: {
        delete: "Gagal menghapus barang keluar",
    },

    success: {
        delete: "Berhasil menghapus barang keluar",
    },
}

export default id_trans_itemoutlist;